import { useNotifications } from '@sequencehq/core-components'
import { useMutation } from '@sequencehq/api/utils'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { logError } from '@sequencehq/utils'

export const useCreateNumeralMapping = () => {
  const { displayNotification } = useNotifications()

  const { mutateAsync: postTaxCategoryNumeralMapping } = useMutation(
    dashboardv99990101Client.postTaxCategoryNumeralMapping
  )

  return async ({
    taxCategoryId,
    numeralProductCategory,
    numeralProductCategoryTitle,
    isDefault
  }: {
    taxCategoryId: string
    numeralProductCategory: string
    numeralProductCategoryTitle: string
    isDefault?: boolean
  }) => {
    try {
      await postTaxCategoryNumeralMapping({
        taxCategoryId,
        numeralProductCategory,
        numeralProductCategoryTitle,
        isDefault
      })

      displayNotification('Tax category mapping created', {
        type: 'success'
      })
    } catch (error) {
      console.error('Failed to create numeral mapping:', error)
      logError(error)

      // Try to extract a more specific error message
      const errorMessage =
        error instanceof Error && error.message
          ? `Failed to create tax category mapping: ${error.message}`
          : 'Failed to create tax category mapping'

      displayNotification(errorMessage, {
        type: 'error'
      })
      throw error // Re-throw so the modal can handle the error
    }
  }
}
